module.exports = __webpack_public_path__ + "img/BACK-001.e3e43a1f.png";